import {useQuery} from '@tanstack/react-query';

import {useApiClient} from '@/hooks';

import {guestApi} from '../api';

const guestKeys = {
  all: ['guest'] as const,
  accounts: () => [...guestKeys.all, 'accounts'] as const
};

export function useGuestAccountsQuery() {
  const client = useApiClient();

  return useQuery({
    queryKey: guestKeys.accounts(),
    queryFn: () => guestApi.fetchAccounts(client),
    // Access can be granted or removed at any time, so never show a stale list on arrival.
    refetchOnMount: 'always',
    select: response => response.data
  });
}
